import Confirm, { ConfirmType } from './Confirm.js';

function CreateConfirm(title, message, type, testoConferma, className, cancelText, confirmPrimary, dontShowAgainId) {
    return Confirm.createModalPromise({
        className, message, confirmText: testoConferma, cancelText, title, type: type || ConfirmType.warning, confirmPrimary, dontShowAgainId,
    });
}

export { CreateConfirm as default };
